export default {
  names: {
    email: 'Email',
    password: 'Lozinka',
    confirmPassword: 'Potvrdi lozinku',
    firstName: 'Ime',
    lastName: 'Prezime',
    newEmail: 'Nova email adresa',
    confirmEmail: 'Potvrdi novu email adresu',
    newPassword: 'Nova lozinka'
  }
}
